import React from "react";

const Arrow = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        {...props}>
        <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g>
                            <path fill="#787B80" d="M8 6L16 16 0 16z" transform="translate(-924 -5807) translate(771 5807) matrix(-1 0 0 1 169 0) matrix(1 0 0 -1 0 16) matrix(1 0 0 -1 0 22)"/>
                            <path fill="#FFF" d="M8 6L14.59 14.243 1.325 14.243z" transform="translate(-924 -5807) translate(771 5807) matrix(-1 0 0 1 169 0) matrix(1 0 0 -1 0 16) matrix(1 0 0 -1 0 20.243)"/>
                            <path fill="#FFF" d="M1 0H15V6H1z" transform="translate(-924 -5807) translate(771 5807) matrix(-1 0 0 1 169 0) matrix(1 0 0 -1 0 16)"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default Arrow;


// WEBPACK FOOTER //
// ./src/components/icons/Arrow.js